module.exports = __webpack_public_path__ + "static/media/cm.fe9f5c55.svg";